import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintNotHandleK10WarningProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import { SimpleMessage } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const WintNotHandleK10Warning: React.FC<WintNotHandleK10WarningProps> = ({ hasDividendProposal, dividendAmount }) => {
  const showWarning = !hasDividendProposal && (dividendAmount ?? 0) > 0;

  return showWarning ? (
    <SimpleMessage
      icon={IconDefinitionConstants.WExclamation}
      displayType={StyleEnums.DisplayType.Warning}
      className={cssExports.v2}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.WintNotHandleK10Warning)}
    </SimpleMessage>
  ) : null;
};

export default WintNotHandleK10Warning;
